/**
 * The category tag shown beside a project name, or null when it would only repeat the name: the
 * default project "Work" in category "Work" reads "Work  Work" otherwise.
 */
export function categoryTagOf(projectName: string, categoryLabel: string): string | null {
  return projectName.trim() === categoryLabel.trim() ? null : categoryLabel;
}
